
import React from "react";
import { Search, Filter, ChevronDown, RotateCcw } from "lucide-react";

const SearchAndFilter = ({ 
  searchQuery, 
  setSearchQuery, 
  showFilters, 
  setShowFilters,
  parentDomain,
  setParentDomain,
  domain,
  setDomain,
  subDomain,
  setSubDomain,
  product,
  setProduct,
  filterOptions,
  handleResetFilters,
  handleParentDomainChange,
  handleDomainChange,
  handleSubDomainChange,
  handleProductChange,
  handleSearchSubmit
}) => {
  return (
    <>
      <div className="search-and-filter">
        <div className="search-input">
          <input
            type="text"
            placeholder="Search"
            className="input"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            onKeyDown={handleSearchSubmit}
          />
          <Search className="search-icon" />
        </div>

        <div className="reset-button-container">
          <button
            className="reset-button"
            onClick={handleResetFilters}
          >
            <RotateCcw className="icon-left" />
            Reset
          </button>

          <button
            className="filter-toggle"
            onClick={() => setShowFilters(!showFilters)}
          >
            <Filter className="icon-left" />
            Filters
            <ChevronDown className={`icon-right ${showFilters ? "rotate" : ""}`} />
          </button>
        </div>
      </div>

      {showFilters && (
        <div className="filter-panel">
          <div className="filter-grid">
            <div className="filter-item">
              <label className="filter-label">Parent Domain</label>
              <select 
                className="select"
                value={parentDomain}
                onChange={handleParentDomainChange}
              >
                <option>All Parent Domains</option>
                {filterOptions?.parentDomains?.map((option, index) => (
                  <option key={index} value={option}>{option}</option>
                ))}
              </select>
            </div>
            <div className="filter-item">
              <label className="filter-label">Domain</label>
              <select 
                className="select"
                value={domain}
                onChange={handleDomainChange}
              >
                <option>All Domains</option>
                {filterOptions?.domains?.map((option, index) => (
                  <option key={index} value={option}>{option}</option>
                ))}
              </select>
            </div>
            <div className="filter-item">
              <label className="filter-label">Sub Domain</label>
              <select 
                className="select"
                value={subDomain}
                onChange={handleSubDomainChange}
              >
                <option>All Sub Domains</option>
                {filterOptions?.subDomains?.map((option, index) => (
                  <option key={index} value={option}>{option}</option>
                ))}
              </select>
            </div>
            <div className="filter-item">
              <label className="filter-label">Product</label>
              <select 
                className="select"
                value={product}
                onChange={handleProductChange}
              >
                <option>All Products</option>
                {filterOptions?.products?.map((option, index) => (
                  <option key={index} value={option}>{option}</option>
                ))}
              </select>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SearchAndFilter;
